import { render, staticRenderFns } from "./SalePaymentDetail.vue?vue&type=template&id=72ae680d&"
import script from "./SalePaymentDetail.vue?vue&type=script&lang=js&"
export * from "./SalePaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports